export default __webpack_public_path__ + "static/media/service-financial.04991dbb.jpg";